module.exports = {
  EQUALS: {
    KEY: 'EQUALS',
    DISPLAY: '=',
    OP: '=',
  },
  LT: {
    KEY: 'LT',
    DISPLAY: '<',
    OP: '<',
  },
  LTE: {
    KEY: 'LTE',
    DISPLAY: '<=',
    OP: '<=',
  },
  GT: {
    KEY: 'GT',
    DISPLAY: '>',
    OP: '>',
  },
  GTE: {
    KEY: 'GTE',
    DISPLAY: '>=',
    OP: '>=',
  },
  BEGINS: {
    KEY: 'BEGINS',
    DISPLAY: 'begins with',
    OP: 'begins_with'
  }
};